import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(private _snackBar: MatSnackBar) {}

  public success(message: string, duration: number = 3000) {
    this.showSnackbar('success', message, duration);
  }

  public error(message: string) {
    this.showSnackbar('error', message, 5000);
  }

  public warning(message: string) {
    this.showSnackbar('warning', message, 7000);
  }

  public info(message: string) {
    this.showSnackbar('info', message, 7000);
  }

  private showSnackbar(type: string, message: string, duration: number = 3000) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: {
        type: type,
        message: message,
        snackBar: this._snackBar,
      },
      duration: duration,
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'snackbar-' + type,
    });
  }

}
